import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { PaginationComponent } from '../pagination/pagination.component';

@Component({
  selector: 'app-table-footer',
  standalone: true,
  imports: [PaginationComponent, TranslocoPipe],
  templateUrl: './table-footer.component.html',
  styleUrl: './table-footer.component.scss'
})
export class TableFooterComponent {
  @Input() page: number = 1;
  @Input() pageSize: number = 10;
  @Input() totalCount: number = 0;
  @Input() totalPages: number = 0;

  @Input() showExport: boolean = false;
  @Input() exportDisabled: boolean = false;

  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() export: EventEmitter<void> = new EventEmitter<void>();

  get showingCount(): number {
    return Math.min((this.page - 1) * this.pageSize + this.pageSize, this.totalCount);
  }
}